import request from '@/utils/request'

export function pageMessage(query) {
  return request({
    url: '/biz/giftcard/message/page',
    method: 'get',
    params: query
  })
}

export function publishMessage(data) {
  return request({
    url: '/biz/giftcard/message/publish',
    method: 'post',
    data
  })
}

export function deleteMessage(id) {
  return request({
    url: '/biz/giftcard/message/delete',
    method: 'post',
    params: { id }
  })
}
